const header = () => {


	//Hide the header as the users scrolls down, reveal it again if they scroll up
	let pageHeader = document.querySelector('#main-header'),
	scrollBuffer = 50; //Pixel buffer of movement before the header is hidden/revealed
	let lastScrollPosition 	= 0;


	document.addEventListener('scroll', (event) => {

		if(scrollY > scrollBuffer){
			if(window.scrollY > (lastScrollPosition + scrollBuffer)){
				//Scrolling down the page
				pageHeader.classList.add('hidden');
				lastScrollPosition = window.scrollY;

			}else if(window.scrollY < (lastScrollPosition - scrollBuffer)){
				//Scrolling back up
				pageHeader.classList.remove('hidden');
				lastScrollPosition = window.scrollY;
			}
		}else{
			pageHeader.classList.remove('hidden');
		}
		
  		
	});
}



header();